window.addEventListener('load', event => {
    const videoCardPanels = document.querySelectorAll('.category-equipment-panel, .category-applications-panel, .category-vehicle-panel');

    for (const videoCardPanel of videoCardPanels) {
        const cards = videoCardPanel.querySelectorAll('[data-video-category-card]');

        cards.forEach(card => {
            const video = card.querySelector('video[data-src]');
            const cover = card.querySelector('.category-card-video-cover');
            if (!video || !cover) return;

            let hasLoaded = false;
            let readyToPlay = false;

            video.addEventListener('loadeddata', () => {
                readyToPlay = true;
                if (card.matches(':hover')) {
                    cover.style.opacity = '0';
                    video.play().catch(() => {});
                }
            });

            card.addEventListener('mouseenter', () => {
                if (!hasLoaded) {
                    video.src = video.dataset.src;
                    video.load();
                    hasLoaded = true;
                }

                if (readyToPlay) {
                    cover.style.opacity = '0';
                    video.play().catch(() => {});
                }
            });

            card.addEventListener('mouseleave', () => {
                cover.style.opacity = '1';
            });

            cover.addEventListener('transitionend', (e) => {
                if (e.propertyName === 'opacity' && cover.style.opacity === '1') {
                    video.pause();
                    video.currentTime = 0;
                }
            });
        });
    }
});
